import { text } from "./text.i18n";

export const appLanguage = { text };
